import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, renderList as _renderList } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 1,
  disabled: ""
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_tabs, {
      activeKey: _ctx.activeKey,
      "onUpdate:activeKey": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.activeKey) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_tab_pane, {
          key: "1",
          tab: "工事計画"
        }, {
          default: _withCtx(() => [
            (!_ctx.editPlanMode)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_a_button, {
                    onClick: _ctx.view,
                    disabled: !_ctx.isAuthority
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("新規作成")
                    ]),
                    _: 1
                  }, 8, ["onClick", "disabled"]),
                  _createVNode(_component_a_table, {
                    bordered: "",
                    "data-source": _ctx.projectSource,
                    columns: _ctx.projectColumns,
                    loading: _ctx.loading
                  }, {
                    bodyCell: _withCtx(({ column, record }) => [
                      (column.dataIndex==='operation')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (_ctx.isAuthority)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createElementVNode("a", {
                                    onClick: ($event: any) => (_ctx.edit(record))
                                  }, "編集", 8, _hoisted_1),
                                  _hoisted_2,
                                  _createElementVNode("a", {
                                    onClick: ($event: any) => (_ctx.editPlan(record))
                                  }, "計画", 8, _hoisted_3)
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createElementVNode("a", {
                                    onClick: ($event: any) => (_ctx.edit(record)),
                                    disabled: ""
                                  }, "編集", 8, _hoisted_4),
                                  _hoisted_5,
                                  _createElementVNode("a", {
                                    onClick: ($event: any) => (_ctx.editPlan(record))
                                  }, "計画", 8, _hoisted_6)
                                ], 64))
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["data-source", "columns", "loading"])
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("h2", null, [
                    _createVNode(_component_a_button, {
                      onClick: _ctx.editPlanCancel,
                      style: {"float":"left"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("取り消し")
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createTextVNode(" " + _toDisplayString(_ctx.editPlanProjectLabel) + "を編集中 ", 1),
                    _createVNode(_component_a_button, {
                      onClick: _ctx.editPlanSave,
                      type: "primary",
                      style: {"float":"right"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("保存")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _createVNode(_component_a_table, {
                    bordered: "",
                    "data-source": _ctx.editPlanSource,
                    columns: _ctx.editPlanColumns,
                    loading: _ctx.loading
                  }, {
                    bodyCell: _withCtx(({ column, record }) => [
                      (column.dataIndex==='code')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (record.code!=null)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString(record.code) + ":" + _toDisplayString(_ctx.workSource.filter(e=>e.code===record.code)[0].label), 1)
                                ], 64))
                              : (_openBlock(), _createBlock(_component_a_select, {
                                  key: 1,
                                  options: _ctx.selectCodeOptions(),
                                  value: record.code,
                                  "onUpdate:value": ($event: any) => ((record.code) = $event),
                                  onSelect: _cache[0] || (_cache[0] = ($event: any) => (_ctx.AddPlan())),
                                  style: {"width":"100%"}
                                }, null, 8, ["options", "value", "onUpdate:value"]))
                          ], 64))
                        : (column.dataIndex==='plan')
                          ? (_openBlock(), _createBlock(_component_a_input_number, {
                              key: 1,
                              value: record.plan,
                              "onUpdate:value": ($event: any) => ((record.plan) = $event),
                              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.AddPlan()))
                            }, null, 8, ["value", "onUpdate:value"]))
                          : (column.dataIndex==='operation')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                (record.code!=null)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      (_ctx.isAuthority)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            onClick: ($event: any) => (_ctx.deletePlan(record))
                                          }, "削除", 8, _hoisted_7))
                                        : (_openBlock(), _createElementBlock("a", _hoisted_8, "削除"))
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["data-source", "columns", "loading"])
                ], 64))
          ]),
          _: 1
        }),
        _createVNode(_component_a_tab_pane, {
          key: "3",
          tab: "部署管理"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              onClick: _ctx.createBusho,
              disabled: !_ctx.isAuthority
            }, {
              default: _withCtx(() => [
                _createTextVNode("新規作成")
              ]),
              _: 1
            }, 8, ["onClick", "disabled"]),
            _createVNode(_component_a_table, {
              bordered: "",
              dataSource: _ctx.bushoSource,
              columns: _ctx.bushoColumns,
              loading: _ctx.loading
            }, {
              bodyCell: _withCtx(({ column, record }) => [
                (column.dataIndex==='operation')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.isAuthority)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            onClick: ($event: any) => (_ctx.editBusho(record))
                          }, "編集", 8, _hoisted_9))
                        : (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            onClick: ($event: any) => (_ctx.editBusho(record)),
                            disabled: ""
                          }, "編集", 8, _hoisted_10))
                    ], 64))
                  : (column.dataIndex==='edittype')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (record.edittype === 0)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" 実績と残業は別入力 ")
                            ], 64))
                          : (record.edittype === 1)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(" 実績に残業を含む ")
                              ], 64))
                            : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["dataSource", "columns", "loading"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_tab_pane, {
          key: "2",
          tab: "作業コード"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              onClick: _ctx.createCode,
              disabled: !_ctx.isAuthority
            }, {
              default: _withCtx(() => [
                _createTextVNode("新規作成")
              ]),
              _: 1
            }, 8, ["onClick", "disabled"]),
            _createVNode(_component_a_table, {
              bordered: "",
              dataSource: _ctx.workSource,
              columns: _ctx.workColumns,
              loading: _ctx.loading
            }, {
              bodyCell: _withCtx(({ column, record }) => [
                (column.dataIndex==='operation')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.isAuthority)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            onClick: ($event: any) => (_ctx.editCode(record))
                          }, "編集", 8, _hoisted_11))
                        : (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            onClick: ($event: any) => (_ctx.editCode(record)),
                            disabled: ""
                          }, "編集", 8, _hoisted_12))
                    ], 64))
                  : (column.dataIndex==='busho')
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.getBushoLabel(record.busho), (busho) => {
                        return (_openBlock(), _createBlock(_component_a_tag, { key: busho }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(busho), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["dataSource", "columns", "loading"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_tab_pane, {
          key: "4",
          tab: "場所"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              onClick: _ctx.createPoint,
              disabled: !_ctx.isAuthority
            }, {
              default: _withCtx(() => [
                _createTextVNode("新規作成")
              ]),
              _: 1
            }, 8, ["onClick", "disabled"]),
            _createVNode(_component_a_table, {
              bordered: "",
              dataSource: _ctx.pointSource,
              columns: _ctx.pointColumns,
              loading: _ctx.loading
            }, {
              bodyCell: _withCtx(({ column, record }) => [
                (column.dataIndex==='operation')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.isAuthority)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            onClick: ($event: any) => (_ctx.editPoint(record))
                          }, "編集", 8, _hoisted_13))
                        : (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            onClick: ($event: any) => (_ctx.editPoint(record)),
                            disabled: ""
                          }, "編集", 8, _hoisted_14))
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["dataSource", "columns", "loading"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["activeKey"]),
    _createVNode(_component_a_modal, {
      open: _ctx.visible,
      "onUpdate:open": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.visible) = $event)),
      title: "工事計画編集",
      footer: null
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_input_group, {
          compact: "",
          style: {"margin":"2px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              placeholder: "工事名",
              value: _ctx.registData.name,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.registData.name) = $event))
            }, null, 8, ["value"]),
            _createVNode(_component_a_input, {
              placeholder: "短縮名",
              value: _ctx.registData.abb,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.registData.abb) = $event))
            }, null, 8, ["value"]),
            _createVNode(_component_a_select, {
              style: {"width":"150px"},
              value: _ctx.registData.states,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.registData.states) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select_option, { value: "0" }, {
                  default: _withCtx(() => [
                    _createTextVNode("作業中")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_select_option, { value: "1" }, {
                  default: _withCtx(() => [
                    _createTextVNode("完了")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"]),
            _hoisted_15,
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: _ctx.regist,
              loading: _ctx.loading,
              disabled: _ctx.registData.name==null
            }, {
              default: _withCtx(() => [
                _createTextVNode("登録")
              ]),
              _: 1
            }, 8, ["onClick", "loading", "disabled"]),
            _createVNode(_component_a_button, {
              type: "primary",
              danger: "",
              onClick: _ctx.deleteRecord,
              loading: _ctx.loading,
              style: {"float":"right"}
            }, {
              default: _withCtx(() => [
                _createTextVNode("削除")
              ]),
              _: 1
            }, 8, ["onClick", "loading"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_a_modal, {
      open: _ctx.codeVisible,
      "onUpdate:open": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.codeVisible) = $event)),
      title: "作業コード編集",
      footer: null
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_input_group, {
          compact: "",
          style: {"margin":"2px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              placeholder: "工事コード",
              value: _ctx.registCode.code,
              "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.registCode.code) = $event))
            }, null, 8, ["value"]),
            _createVNode(_component_a_input, {
              placeholder: "作業名",
              value: _ctx.registCode.label,
              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.registCode.label) = $event))
            }, null, 8, ["value"]),
            _createVNode(_component_a_select, {
              options: _ctx.selectbusho,
              value: _ctx.registCode.busho,
              "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.registCode.busho) = $event)),
              placeholder: "部署",
              mode: "tags",
              style: {"width":"100%"}
            }, null, 8, ["options", "value"])
          ]),
          _: 1
        }),
        _hoisted_16,
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _ctx.registWorkCode,
          loading: _ctx.loading,
          disabled: _ctx.registCode.code==null||_ctx.registCode.label==null
        }, {
          default: _withCtx(() => [
            _createTextVNode("登録")
          ]),
          _: 1
        }, 8, ["onClick", "loading", "disabled"]),
        _createVNode(_component_a_button, {
          type: "primary",
          danger: "",
          onClick: _ctx.deleteCode,
          loading: _ctx.loading,
          style: {"float":"right"},
          disabled: _ctx.registCode.id==0
        }, {
          default: _withCtx(() => [
            _createTextVNode("削除")
          ]),
          _: 1
        }, 8, ["onClick", "loading", "disabled"])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_a_modal, {
      open: _ctx.bushoVisible,
      "onUpdate:open": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.bushoVisible) = $event)),
      title: "部署編集",
      footer: null
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_input, {
          placeholder: "部署名",
          value: _ctx.registBusho.label,
          "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.registBusho.label) = $event))
        }, null, 8, ["value"]),
        _createVNode(_component_a_select, {
          style: {"width":"100%","margin-bottom":"5px"},
          value: _ctx.registBusho.edittype,
          "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.registBusho.edittype) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_select_option, { value: 0 }, {
              default: _withCtx(() => [
                _createTextVNode("実績と残業は別入力")
              ]),
              _: 1
            }),
            _createVNode(_component_a_select_option, { value: 1 }, {
              default: _withCtx(() => [
                _createTextVNode("実績に残業を含む")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"]),
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _ctx.registBushoData,
          loading: _ctx.loading,
          disabled: _ctx.registBusho.label==null || _ctx.registBusho.edittype == null
        }, {
          default: _withCtx(() => [
            _createTextVNode("登録")
          ]),
          _: 1
        }, 8, ["onClick", "loading", "disabled"]),
        _createVNode(_component_a_button, {
          type: "primary",
          danger: "",
          onClick: _ctx.deleteBusho,
          loading: _ctx.loading,
          style: {"float":"right"},
          disabled: _ctx.registBusho.id==0
        }, {
          default: _withCtx(() => [
            _createTextVNode("削除")
          ]),
          _: 1
        }, 8, ["onClick", "loading", "disabled"])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_a_modal, {
      open: _ctx.pointVisible,
      "onUpdate:open": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.pointVisible) = $event)),
      title: "場所編集",
      footer: null
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_input, {
          placeholder: "場所名",
          value: _ctx.registPoint.label,
          "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.registPoint.label) = $event))
        }, null, 8, ["value"]),
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _ctx.registPointData,
          loading: _ctx.loading,
          disabled: _ctx.registPoint.label==null
        }, {
          default: _withCtx(() => [
            _createTextVNode("登録")
          ]),
          _: 1
        }, 8, ["onClick", "loading", "disabled"]),
        _createVNode(_component_a_button, {
          type: "primary",
          danger: "",
          onClick: _ctx.deletePoint,
          loading: _ctx.loading,
          style: {"float":"right"},
          disabled: _ctx.registPoint.id==0
        }, {
          default: _withCtx(() => [
            _createTextVNode("削除")
          ]),
          _: 1
        }, 8, ["onClick", "loading", "disabled"])
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}